import { render, staticRenderFns } from "./ListOrder.vue?vue&type=template&id=423f6954&scoped=true"
import script from "./ListOrder.vue?vue&type=script&lang=ts"
export * from "./ListOrder.vue?vue&type=script&lang=ts"
import style0 from "./ListOrder.vue?vue&type=style&index=0&id=423f6954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423f6954",
  null
  
)

export default component.exports